import React from "react";

import { getJarisMerchantPortfolioUrl } from "globalConstants";

import styles from "./layout.module.scss";

type JarisBankInfoNoticeProps = {
	jarisMerchantId?: string;
	jarisShopId?: string;
};

/**
 * Shown above Bank Info on the merchant edit form when the merchant's settlement
 * account is managed through Jaris. The fields stay editable on purpose - the
 * point is that edits here do not reach Jaris, not that they are forbidden.
 */
export const JarisBankInfoNotice = ({
	jarisMerchantId,
	jarisShopId,
}: JarisBankInfoNoticeProps) => {
	const href = getJarisMerchantPortfolioUrl(jarisMerchantId, jarisShopId);

	return (
		<div className={styles.jarisBankInfoNotice}>
			Bank account changes must be made in Jaris. Updates made here
			won&rsquo;t affect fund settlement.
			{href && (
				<>
					{" "}
					<a href={href} target="_blank" rel="noreferrer">
						Update in Jaris
					</a>
				</>
			)}
		</div>
	);
};
